import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  deleteMatrix,
  matrixQueries,
  type MatrixListItemUi,
} from "@/domains/matrix";

// The id comes from the mutate call: the rail deletes any matrix, not just the open one.
export function useDeleteMatrix() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (collectionId: string) => deleteMatrix(collectionId),
    onSuccess: (_data, collectionId) => {
      // Dropped before the caller navigates: an invalidation resolves too late.
      queryClient.setQueryData<MatrixListItemUi[]>(
        matrixQueries.list().queryKey,
        (previous) =>
          previous?.filter((matrix) => matrix.collectionId !== collectionId),
      );
      queryClient.removeQueries(matrixQueries.detail(collectionId));
      void queryClient.invalidateQueries(matrixQueries.lists());
    },
  });
}
